module.exports = __webpack_public_path__ + "static/media/p006.bb307815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p006.jpg
// module id = 1519
// module chunks = 0